
import { container } from '@eureka/services/src/container';
import type { ICoreDataWrapper } from '@eureka/services/src/exception';
import type { IResponseDbConfigData } from './type';

export function getDbConfig() {
    return container.RnDHttp.get<ICoreDataWrapper<IResponseDbConfigData>>({
        url: `${import.meta.env.VITE_CORE_BASIC_SERVICE_URI}/core-basic-api/analytics/db-select/config`,
    }).then((res) => {
        return res.data
    })
}
